"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var window_or_global_1 = __importDefault(require("window-or-global"));
function processParams(parameters) {
    var parameterList = Object.keys(parameters)
        .map(function (key) {
        return key + "=" + encodeURIComponent(parameters[key]);
    })
        .join('&');
    return parameterList;
}
exports.processParams = processParams;
function parseHTML(htmlString) {
    var html = window_or_global_1.default.document.createElement('div');
    html.innerHTML = htmlString;
    return html;
}
exports.parseHTML = parseHTML;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VybC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNFQUFvQztBQU9wQyxTQUFnQixhQUFhLENBQUMsVUFBZTtJQUN6QyxJQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztTQUN4QyxHQUFHLENBQUMsVUFBQSxHQUFHO1FBQ0osT0FBVSxHQUFHLFNBQUksa0JBQWtCLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFHLENBQUM7SUFDM0QsQ0FBQyxDQUFDO1NBQ0QsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2YsT0FBTyxhQUFhLENBQUM7QUFDekIsQ0FBQztBQVBELHNDQU9DO0FBRUQsU0FBZ0IsU0FBUyxDQUFDLFVBQWtCO0lBQ3hDLElBQU0sSUFBSSxHQUFHLDBCQUFJLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNoRCxJQUFJLENBQUMsU0FBUyxHQUFHLFVBQVUsQ0FBQztJQUM1QixPQUFPLElBQUksQ0FBQztBQUNoQixDQUFDO0FBSkQsOEJBSUMifQ==